/*
 * Рамка экранов мастера. Геометрия из макета «Мастер - П0»: ширина 360, нижние вкладки
 * 64 px, индикатор активной вкладки 22×4, все цели нажатия не меньше 48 px.
 *
 * ПОЧЕМУ НЕ ФИКСИРОВАННЫЕ 360. Макет нарисован на 360, но это НИЖНЯЯ граница, а не
 * единственная: у мастера в кармане может быть и 390, и 430. Поэтому рамка тянется
 * на всю ширину и ограничена сверху, чтобы на планшете и на мониторе не превращаться
 * в строку длиной в экран — читать имя клиента через весь монитор невозможно.
 */

.frame {
  display: flex;
  flex-direction: column;
  /* dvh, а не vh: на телефоне адресная строка браузера уезжает и приезжает, а нижние
     вкладки обязаны оставаться на месте, а не прыгать под пальцем. */
  height: 100dvh;
  max-width: 480px;
  margin: 0 auto;
  background: var(--bg-workspace);
  color: var(--text-primary);
  overflow: hidden;
}

.body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  /* Инерционная прокрутка и отсутствие «оттяжки» страницы целиком. */
  overscroll-behavior: contain;
  display: flex;
  flex-direction: column;
}

/* ─────────── нижние вкладки ─────────── */

.tabbar {
  flex: none;
  height: var(--mobile-tabbar-height);
  display: flex;
  background: var(--bg-card);
  border-top: 1px solid var(--border);
  /* Домашняя полоса телефона: без этого нижняя вкладка попадает под неё. */
  padding-bottom: env(safe-area-inset-bottom, 0);
}

.tab {
  flex: 1;
  min-width: var(--touch-min-target);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  text-decoration: none;
  color: var(--text-secondary);
  font-size: var(--font-size-2xs);
  font-weight: var(--font-weight-semibold);
}

.tabActive {
  color: var(--text-primary);
}

.tabMark {
  width: 22px;
  height: 4px;
  border-radius: 2px;
  background: transparent;
}

.tabActive .tabMark {
  background: var(--accent);
}

.tabLabel {
  text-align: center;
}

.tab:focus-visible {
  outline: var(--focus-ring-width) solid var(--focus-ring-color);
  outline-offset: calc(var(--focus-ring-offset) * -1);
}

/* ─────────── шапка экрана ─────────── */

.head {
  flex: none;
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-4) var(--space-1);
}

.headText {
  min-width: 0;
}

.headTitle {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  line-height: 1.1;
}

.headSubtitle {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.headActions {
  margin-left: auto;
  flex: none;
  display: flex;
  gap: var(--space-1);
}

/* ─────────── строка возврата ─────────── */

.backBar {
  flex: none;
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-1) var(--space-3);
}

.back {
  /* 44 px — цель нажатия из макета; ниже неё палец промахивается мимо стрелки. */
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-lg);
  font-size: var(--font-size-xl);
  color: var(--text-primary);
  text-decoration: none;
}

.back:focus-visible {
  outline: var(--focus-ring-width) solid var(--focus-ring-color);
  outline-offset: calc(var(--focus-ring-offset) * -1);
}

.backLabel {
  font-size: var(--font-size-md);
  color: var(--text-secondary);
}

.backRight {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.notEmployee {
  margin: var(--space-4);
}
